module.exports = __webpack_public_path__ + "static/media/09_crisalide.a8c75f24.jpg";